import { IDocument } from "../interfaces/document.interface";

const useDocument = (data: IDocument) => {
    document.title = `Cigo — ${data.title}`;
}

export default useDocument